const MODULE_LABELS = {
    polls: "Опитування",
    requests: "Заявки",
    feedbacks: "Відгуки",
    cars: "Авто",
    chat: "Чат",
};

export function formatRestrictionUntil(iso) {
    if (!iso) return null;
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return null;
    return d.toLocaleString("uk-UA");
}

export function isModuleReadonly(restriction, module) {
    if (!restriction) return false;
    const key = String(module || "").toLowerCase();
    const list = Array.isArray(restriction.readonly_modules) ? restriction.readonly_modules : [];
    return list.map((x) => String(x).toLowerCase()).includes(key);
}

export function isChatMuted(restriction) {
    return Boolean(restriction?.chat_muted);
}

/** Human message for a blocked write action / banner. */
export function formatRestrictionMessage(restriction, module = null) {
    const reason = (restriction?.reason || "").trim();
    const until = formatRestrictionUntil(restriction?.chat_muted_until);

    if (module === "chat" || (!module && isChatMuted(restriction))) {
        let msg = "Чат тимчасово обмежено оператором";
        if (until) msg += `. Буде розблоковано: ${until}`;
        else msg += ".";
        if (reason) msg += ` Причина: ${reason}`;
        return msg;
    }

    const label = MODULE_LABELS[module] || "Цей розділ";
    let msg = `${label} обмежено оператором (лише перегляд).`;
    if (isChatMuted(restriction) && until) {
        msg += ` Буде розблоковано: ${until}`;
    }
    if (reason) msg += ` Причина: ${reason}`;
    return msg;
}

/** Normalize FastAPI detail (string | object | array) into a user-facing string. */
export function formatApiErrorDetail(detail, fallback = "Помилка запиту") {
    if (detail == null || detail === "") return fallback;

    if (typeof detail === "string") return detail;

    if (Array.isArray(detail)) {
        const parts = detail
            .map((item) => {
                if (typeof item === "string") return item;
                if (item && typeof item === "object") return item.msg || item.message || "";
                return "";
            })
            .filter(Boolean);
        return parts.join("; ") || fallback;
    }

    if (typeof detail === "object") {
        const code = detail.code;
        const until = formatRestrictionUntil(detail.chat_muted_until);
        const reason = (detail.reason || "").trim();

        if (code === "chat_muted") {
            let msg = detail.message || "Чат тимчасово обмежено оператором";
            if (until) msg = `Чат тимчасово обмежено оператором. Буде розблоковано: ${until}`;
            if (reason) msg += ` Причина: ${reason}`;
            return msg;
        }

        if (code === "module_readonly") {
            const module = detail.module;
            const label = MODULE_LABELS[module] || "Розділ";
            let msg = detail.message || `${label} обмежено оператором (лише перегляд).`;
            if (!String(msg).includes("обмежен")) {
                msg = `${label} обмежено оператором (лише перегляд).`;
            }
            if (until) msg += ` Буде розблоковано: ${until}`;
            if (reason) msg += ` Причина: ${reason}`;
            return msg;
        }

        if (detail.message) return String(detail.message);
        if (detail.msg) return String(detail.msg);
        try {
            return JSON.stringify(detail);
        } catch (_) {
            return fallback;
        }
    }

    return String(detail);
}

export async function readApiErrorMessage(res, fallback = "Помилка запиту") {
    const err = await res.json().catch(() => ({}));
    return formatApiErrorDetail(err?.detail, fallback);
}
